import type { MenuProps } from "antd";
import type { NavigateFunction } from "react-router-dom";
import { IdcardOutlined, LogoutOutlined, ShoppingOutlined } from "@ant-design/icons";
import { globalModel } from "../../global/GlobalModel";

export function standaloneTactikUserMenu(opts: {
  navigate: NavigateFunction;
}): MenuProps {
  const { navigate } = opts;
  return {
    items: [
      { key: "profile", label: "个人资料", icon: <IdcardOutlined /> },
      { key: "orders", label: "我的订单", icon: <ShoppingOutlined /> },
      {
        key: "logout",
        label: "退出登录",
        icon: <LogoutOutlined />,
      },
    ],
    onClick: ({ key }) => {
      if (key === "profile") {
        navigate("/tactik/profile");
        return;
      }
      if (key === "orders") {
        navigate("/tactik/orders");
        return;
      }
      if (key === "logout") {
        void globalModel.logout();
      }
    },
  };
}
